import { getAbility } from "@/helpers/permission";
import { errorHandler } from "@/services/toastHandler";

const state = () => ({
  loading: false,
  error: "",
});

export default {
  namespaced: true,
  state: state(),

  mutations: {
    LOADING: (s) => Object.assign(s, state(), { loading: true }),
    SET_ERROR: (s, error) => (s.error = error),
    LOADED: (s) => (s.loading = false),
  },

  actions: {
    async loginAsync({ commit, dispatch }, payload) {
      commit("LOADING");
      try {
        const { data: response } = await this.$api.post(
          "/v1/admin-users/sign-in",
          payload
        );

        const data = response.data;
        if (data.user.roles.length === 0) {
          dispatch("auth/purgeAuth", null, { root: true });
          return errorHandler("Login failed!");
        }
        const formatData = {
          ...response.data,
          role: "admin",
        };
       

        dispatch("auth/setAbility", getAbility(formatData.role), {
          root: true,
        });
        dispatch("auth/setAuth", formatData, { root: true });

         if (data.user.roles.length > 0) {
          // const res = await dispatch(
          //   "user/admin/getRoleList",
          //   {
          //     id: data.user.userId,
          //     additionalDetail: "withPermissions",
          //     roleId: data.user.roles[0]?.roleId,
          //   },
          //   { root: true }
          // );
          // if (res && res.data && Object.keys(res.data).length) {
            const permissions = data.user.roles?.[0]?.permissions || [];
            dispatch("auth/setPermissions", permissions, { root: true });
          // }
        }
        return formatData;
      } catch (error) {
        errorHandler(error);
      } finally {
        commit("LOADED");
      }
    },
    // SSO landing: the token comes from the URL fragment, so the user and
    // permissions are fetched with it and stored exactly as loginAsync does.
    async ssoLoginAsync({ dispatch }, { token, expireAt }) {
      const { data: response } = await this.$api.get("/v1/admin-users/me", {
        headers: { Authorization: `Bearer ${token}` },
      });
      // /me returns the user object directly in `data`
      const user = response.data;
      if (!user?.roles?.length) throw new Error("no role");

      const formatData = {
        user,
        accessToken: { token, expireAt },
        role: "admin",
      };
      dispatch("auth/setAbility", getAbility(formatData.role), { root: true });
      dispatch("auth/setAuth", formatData, { root: true });
      dispatch("auth/setPermissions", user.roles[0].permissions || [], {
        root: true,
      });
      return formatData;
    },
  },
};
